import { CustomButton } from "../../components/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import styles from "./style.module.css";
import { Text } from "../../components/Text";
import {
  API_FB_CREATE_APP,
  API_FB_APP_STATUS,
} from "../../api/account.service";
import { useEffect, useRef, useState } from "react";
import { ReactComponent as FacebookIcon } from "../../svg/Facebook.svg";
import { ReactComponent as DummyVideoIcon } from "../../svg/dummy-video.svg";

import { Divider } from "primereact/divider";
import { Link, useParams } from "react-router-dom";
import { fbStatus } from "./fb-constants";
import { subscription } from "../../reducers/authSlice";
import { useLayout } from "../../context/LayoutContext";
import Loader from "../../components/Loader";
import { Fieldset } from "primereact/fieldset";
import CopyInput from "./CopyInput";
import { set } from "react-hook-form";
import { Toast } from 'primereact/toast';
function FbRegistrationModule() {
  const [appStatus, setStatus] = useState(fbStatus.PENDING);
  const { user } = useSelector((state) => state.authenticate);
  const [createAppLoading, setAppLoading] = useState(false);
  const [generatedURLLoading, setGeneratedURLLoading] = useState(false);
  const { toastMassage, setLoading } = useLayout();
  const [generatedURL, setGeneratedURL] = useState("");
const toast = useRef(null);
 
  const dispatch = useDispatch();
  const { companyId } = useParams();
  const createAppCall = () => {
    setAppLoading(true);
    API_FB_CREATE_APP(companyId)
      .then((data) => {
        setAppLoading(false);
        window.open(data.link, "_blank");
      })
      .catch((err) => {
        setAppLoading(false);
        toastMassage("error");
      });
  };

  const handleGenerateURL = () => {
    setGeneratedURLLoading(true);
    API_FB_CREATE_APP(companyId)
      .then((data) => {
        setGeneratedURLLoading(false);
        setGeneratedURL(data.link);
        toast.current.show({severity:'success', summary: 'URL is created', detail:data?.message, life: 3000});
      })
      .catch((err) => {
        setGeneratedURLLoading(false);
        toastMassage("error");
      });
  };

  const handleOpenFBModule = () => {
    createAppCall();
  };

  const fetchStatus = async () => {
    try {
      const data = await API_FB_APP_STATUS(companyId);

      if (!data) {
        toastMassage("Failed to fetch app status. Empty response.");
      }

      if (data.status !== fbStatus.PENDING && data?.companyId) {
        await dispatch(subscription(user?.companyId)).unwrap().then(() => {
         toast.current.show({severity:'success', summary: 'Success', detail:'Message Content', life: 3000});
        } );
      } else {
        setStatus(data?.status || fbStatus.PENDING);
        toast.current.show({severity:'success', summary: 'Success', detail:data?.message, life: 3000});
      }
    } catch (error) {
      console.error("Error in fetchStatus:", error);

      const errorMsg =
        error?.message ||
        "An unexpected error occurred while checking app status.";
      toastMassage(errorMsg, "error");
    }
  };

  return (
    <Fieldset style={{ background: "#FFFFF" }}>
      <Toast ref={toast} />
      <div className="flex justify-content-center align-items-center w-full">
        <div
          className={`my-3 w-full lg:w-8 pl-3 ${styles["fb-registration-module"]}`}
        >
          <Loader />
          <div className="fb-app-status  mb-3 mx-auto">
            <Text
              type={"heading"}
              color={"#58585A"}
              cust="flex flex-row gap-2 align-items-center"
            >
              Your app status is :<br />
              <div className="flex">
                <div className={`py-2 px-5 ${styles["fb-status-tag"]}`}>
                  <Text type={"heading"} color={"#060405"}>
                    {appStatus}
                  </Text>
                </div>
              </div>
            </Text>
          </div>
          <Text type={"heading"}>
            Please follow the steps below to register your app on Facebook:
          </Text>
          <div className="my-3">
            <Text type={"sub-heading"}>1. New Phone Number</Text>
            <div className=" my-3">
              <Text color={"#1a1a1a80"} type={"small-text"}>
                Ensure you use a phone number that isn't already linked to
                WhatsApp during registration. This helps ensure a smooth
                registration process.
              </Text>
            </div>
          </div>
          <Text type={"sub-heading"}>2. App Registration on Facebook</Text>
          <div className="my-3">
            <button
              className={`${styles["fb-regisation-btn"]} flex align-items-center gap-3 justify-content-center px-8 cursor-pointer py-3 border-0`}
              onClick={handleOpenFBModule}
            >
              {createAppLoading ? (
                <div className="text-center">
                  <i className="pi pi-spinner" />
                </div>
              ) : (
                <>
                  <FacebookIcon />
                  <span>Continue with Facebook</span>
                </>
              )}
            </button>
          </div>
          <div>
            <div className="my-3 mb-3">
              {generatedURL ? (
                <CopyInput value={generatedURL} />
              ) : (
                <>
                  <button
                    className={`${styles["fb-regisation-btn"]} flex align-items-center gap-3 justify-content-center px-8 cursor-pointer py-3 border-0`}
                    onClick={handleGenerateURL}
                  >
                    {generatedURLLoading ? (
                      <div className="text-center">
                        <i className="pi pi-spinner" />
                      </div>
                    ) : (
                      <>
                        {/* <FacebookIcon /> */}
                        <span>Generate URL </span>
                      </>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
          <Text type={"sub-heading"}>
            3. After completing the Facebook registration, please click the
            below button.
          </Text>
          <div className="my-3">
            <CustomButton label="Check Status" onClick={fetchStatus} />
          </div>
          <Divider />
          <div>
            <div className="flex align-items-center pl-2">
              <Text>For more clarity, watch this video.</Text>
              <CustomButton
                varient="text"
                icon={<DummyVideoIcon />}
                label={
                  <Link
                    to={`https://www.youtube.com/watch?v=8kICTq323DE`}
                    style={{ textDecoration: "none" }}
                    target="_"
                  >
                    <Text
                      color={"#34629A"}
                      style={{
                        marginLeft: "10px",
                        textDecoration: "underline",
                      }}
                    >
                      Watch Video
                    </Text>
                  </Link>
                }
              />
            </div>

            <div
              className={`flex flex-wrap align-items-center justify-content-between p-3 ${styles["sales-help"]}`}
            >
              <div className="text-left">
                <div className="flex justify-content-end align-items-center">
                  <Text type={"heading"} style={{ fontSize: "1.2rem" }}>
                    Priyanka&nbsp;Ganguly,
                  </Text>
                  <Text
                    style={{
                      fontSize: "1rem",
                      marginLeft: "0.4rem",
                      marginTop: "0.3rem",
                    }}
                  >
                    Sales&nbsp;Manager
                  </Text>
                </div>
                <Link
                  to={`https://wa.me/${+919900064161}`}
                  style={{ textDecoration: "none" }}
                  target="_"
                >
                  <div className="flex gap-1 align-items-center mt-1">
                    <i
                      className="pi pi-whatsapp"
                      style={{
                        fontSize: "0.8rem",
                        marginRight: "5px",
                        color: "#868C8A",
                      }}
                    />
                    <Text type={"sub-heading"} color={"#000000"}>
                      +91 9900064161
                    </Text>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          {/* {FbRegistrationModule && (
          <CustomDialog
            visible={FbRegistrationModule}
            onHide={handleHideFBModule}
            header={<Text>Register on Facebook</Text>}
            className="h-full"
          >
            <div className="h-full">
              <iframe
                src={gupshupUrl}
                title="description"
                className={`w-full h-full ${styles[`fb-iframe`]}`}
              ></iframe>
            </div>
          </CustomDialog>
        )} */}
        </div>
      </div>
    </Fieldset>
  );
}

export default FbRegistrationModule;
